// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"7fe1d86a","132":"a28c6001","205":"8c970a51","614":"195f856c"}[chunkId] + ".chunk.js";
};